import * as Html from "../../util/Html.ts";
export {init}
Html.registerWidget('widget/specific/price-widget',{init:init})

function init(obj){
  let 
    selectable = obj.find('flexrow>div'),
    yearly = obj.find('.controlled.yearly'),
    monthly = obj.find('.controlled.monthly');
  
  selectable.on('click',function(){
    selectable.removeClass('selected')
    $(this).addClass('selected');
    if($(this).hasClass('yearly')){
      yearly.show();
      monthly.hide();
    }else{
      yearly.hide();
      monthly.show();
    }
    
  })
}